module.exports = __webpack_public_path__ + "img/customer_zjdx.db2bf157.svg";